import { render, staticRenderFns } from "./SelectedUniversity.vue?vue&type=template&id=44faf99d&scoped=true&"
import script from "./SelectedUniversity.vue?vue&type=script&lang=js&"
export * from "./SelectedUniversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44faf99d",
  null
  
)

export default component.exports